var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e52d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb1d31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8dd4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9da38"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.047619 1.142857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.52380952 1.14285714h-1.52380952l-1.14285714 2.66666667-1.14285715-.76190476s-.8296735-1.97253065-1.14285714-2.28571429c-.31318363-.31318363-.63073055-.02347025-1.62248884.26571801-.99175828.28918826-1.03022693.62090774-1.41815476.62090774-.1569638 0-.65636431-.57864148-.93480283-.75148809-.40970772-.25433477-.55738467-.13513765-.45861235.24581473.04269293.16466124.36800543.36787675.57412576.66341146.27074981.38820025.43136159.86039806.43136159.86039806s.37145759-.34718888.57133557-.40429687c.30331471-.08666135.64494401.06203204 1.04510788 0 .50884997-.07888019 1.05022322-.3576079 1.05022322-.3576079l.13244048 1.452939s-1.81231399 1.68411255-1.65625 2.35658481c.15606398.67247227 1.88107517 1.49823293 2.28571428 2.0874256.40463911.58919277-.24051339.8088256-.24051339 1.09179688s-.06724884.66002461.24051339.54678202c.30776223-.11324267.34502373-.60382659.62732515-1.04938621.19420204-.30651131.3505539-.46804777.37741816-.58919269.06591542-.29724703-.78298275-1.07753635-1.2452567-1.63067337-.22020373-.26348625-.6640625-.62090773-.6640625-.62090773l1.309215-.97870164s2.25988842.93343571 2.76965407.62239583c.50976556-.31103987.63523063-3.2890625.63523063-3.2890625l1.57118309-.38095238z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.71428571 7.61904762c-.21039418 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.17055819.38095239.38095238 0 .21039418-.1705582.38095238-.38095239.38095238zm1.52380953-6.0952381c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm0 3.04761905c-.21039419 0-.38095238-.17055819-.38095238-.38095238s.17055819-.38095238.38095238-.38095238c.21039418 0 .38095238.17055819.38095238.38095238s-.1705582.38095238-.38095238.38095238zm-4.57142857 1.52380953c-.21039419 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095239-.38095238.38095239zm1.52380952-4.57142858c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055819.38095238-.38095238.38095238zm.76190476 3.04761905c-.21039418 0-.38095238-.34111638-.38095238-.76190476s.1705582-.76190476.38095238-.76190476c.21039419 0 .38095238.34111638.38095238.76190476s-.17055819.76190476-.38095238.76190476zm-3.80952381-1.52380952c-.21039418 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.17055819.38095238.38095238 0 .21039418-.17055819.38095238-.38095238.38095238z",
    fill: "url(#d)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm);
export default __webpack_public_path__ + "static/media/IM.30142540b9913c5444c50c3cd55c8bfe.svg";
export { ForwardRef as ReactComponent };